import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { applications } from 'src/app/shared/utils';
import { SwitchAppService } from 'src/app/switch-app.service';

@Component({
  selector: 'app-updated-password',
  templateUrl: './updated-password.component.html',
  styleUrls: ['./updated-password.component.css'],
})
export class UpdatedPasswordComponent implements OnInit {
  private clientId: string;
  private applications = applications();
  constructor(
    activatedRoute: ActivatedRoute,
    private resolve: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef,
    private switchApp: SwitchAppService
  ) {
    activatedRoute.queryParams.subscribe((query) => {
      this.clientId = query['client_id'];
    });
    const app = this.applications.find((e) => e.clientId === this.clientId);

    if (app) {
      this.switchApp.setComponent(
        this.clientId,
        app.type,
        this.viewContainerRef,
        this.resolve,
        'updatedPassword'
      );
    }
  }

  ngOnInit(): void { }
}
